// Shopify adds 'content-disposition: attachment' to SVGs so we fetch them via
// JS to prevent a download dialog being triggered.
document.querySelectorAll('object[data-svg]').forEach(el => {
  fetch(el.dataset.svg)
    .then(r => r.text())
    .then(text => {
      const tmp = document.createElement('div');
      tmp.innerHTML = text;
      const newEl = tmp.firstElementChild;
      newEl.setAttribute('width', el.getAttribute('width'));
      newEl.setAttribute('height', el.getAttribute('height'));
      newEl.setAttribute('class', el.getAttribute('class'));
      el.replaceWith(newEl);
    });
});

// scroll down on buy btn click - disable due to safari bug.
document.querySelectorAll('.btn-buy-now').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    const target =
      document.querySelector('#buy_form')?.closest('section') ??
      document.querySelector('#buy-now');
    if (target)
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY,
        behavior: 'smooth',
      });
  });
});

// Scroll to reviews on ratings widget click
document.querySelectorAll('.ratings-widget').forEach(el => {
  el.addEventListener('click', () => {
    document
      .querySelector('#product_reviews')
      ?.scrollIntoView({ behavior: 'smooth' });
  });
});

// Fancy thumb lightbox
window.photoswipe({
  children: [...document.querySelectorAll('a.fancy-thumb')],
});

// Prevent bug where Safari shows a border around bg images before they load
document.querySelectorAll('.product-section .bg img').forEach(img => {
  img.setAttribute('imageLoaded', img.complete);
  img.addEventListener('load', () => {
    img.setAttribute('imageLoaded', 'true');
  });
});
